module.exports = __webpack_public_path__ + "img/batteryAlt.aef539dd.svg";